export var EServiceType;
(function (EServiceType) {
    EServiceType[EServiceType["SERVICE_TYPE_NONE"] = 0] = "SERVICE_TYPE_NONE";
    /**
     * Customer will pickup order and consume at location
     */
    EServiceType[EServiceType["SERVICE_TYPE_PICKUP"] = 1] = "SERVICE_TYPE_PICKUP";
    /**
     * Customer will pickup order at location but consume off premises
     */
    EServiceType[EServiceType["SERVICE_TYPE_TAKEOUT"] = 2] = "SERVICE_TYPE_TAKEOUT";
    /**
     * Order will be delivered to customer off premises
     */
    EServiceType[EServiceType["SERVICE_TYPE_DELIVERY"] = 3] = "SERVICE_TYPE_DELIVERY";
    /**
     * Order will be delivered to customer at a drive-thru window
     */
    EServiceType[EServiceType["SERVICE_TYPE_DRIVE_THRU"] = 4] = "SERVICE_TYPE_DRIVE_THRU";
    /**
     * Order will be delivered to customer at an assigned table
     *
     * This type is only used for table service
     */
    EServiceType[EServiceType["SERVICE_TYPE_SEATED"] = 5] = "SERVICE_TYPE_SEATED";
    /**
    * Order will be delivered to customer at an assigned table
    *
    * This type is only used for table service
    */
    EServiceType[EServiceType["SERVICE_TYPE_CURBSIDE"] = 9] = "SERVICE_TYPE_CURBSIDE";
    /**
    * Order is for collecing payment only.
    *
    * This type is only used for table service
    */
    EServiceType[EServiceType["SERVICE_TYPE_BILL_ONLY"] = 10] = "SERVICE_TYPE_BILL_ONLY";
    /**
    * Reservation asset is for collecing feedback only.
    *
    * This type is only used for standalone loyalty
    */
    EServiceType[EServiceType["SERVICE_TYPE_FEEDBACK_ONLY"] = 11] = "SERVICE_TYPE_FEEDBACK_ONLY";
})(EServiceType || (EServiceType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/models/interfaces/Orders/EServiceType.ts
// module id = RuhK
// module chunks = 18